import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";

const apiKey = process.env.REACT_APP_FIREBASE_API_KEY;
const vapidKeyID = process.env.REACT_APP_FIREBASE_VAPID_KEY;

const firebaseConfig = {
  apiKey: apiKey,
  authDomain: "pixell-ip.firebaseapp.com",
  projectId: "pixell-ip",
  storageBucket: "pixell-ip.firebasestorage.app",
  messagingSenderId: "471747182158",
  appId: "1:471747182158:web:472937fc91c3bf6a8a4d1f",
  measurementId: "G-P9ZQELVGSL",
};

// Initialize Firebase app
export const app = initializeApp(firebaseConfig);

let messaging = null;

// Check if messaging is supported before initializing
isSupported().then((supported) => {
  if (supported && typeof window !== "undefined") {
    messaging = getMessaging(app);
    console.log("Firebase Messaging initialized.");
  } else {
    console.warn("Firebase Messaging is not supported in this browser.");
  }
});

export const generateToken = async () => {
  try {
    if (!messaging) {
      console.warn("Messaging is not initialized or not supported.");
      return null;
    }

    const token = await getToken(messaging, { vapidKey: vapidKeyID });
    return token;
  } catch (error) {
    console.error("Error generating token:", error);
    return null;
  }
};

// Listen for foreground messages (only if messaging is supported)
isSupported().then((supported) => {
  if (supported && typeof window !== "undefined" && messaging) {
    onMessage(messaging, (payload) => {
      //console.log("Foreground Message Received:", payload);

      if (payload.notification) {
        const notificationTitle = payload.notification.title;
        const notificationOptions = {
          body: payload.notification.body,
          icon: payload.notification.icon || "/firebase-logo.png",
        };

        // Show notification if permissions are granted
        if (Notification.permission === "granted") {
          new Notification(notificationTitle, notificationOptions);
        } else {
          console.warn("Notifications permission not granted!");
        }
      }
    });
  }
});
